import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Row,
  Select,
  Tag,
  Typography
} from 'antd';
import {useForm} from 'antd/es/form/Form';
import {connect, useSelector} from 'react-redux';
import TypographyCurrency from '../CurrencySelect/TypographyCurrency';
import React, {useEffect, useState} from 'react';
import {API} from 'aws-amplify';
import dayjs from 'dayjs';
import {Log} from '../../AppUtil';

const {Title} = Typography;

const TransferIssue = props => {
  const [form] = useForm();
  const [componentState, setComponentState] = useState({
    currencyList: [],
    transfer: null,
    transferStatus: [],
    holdingAccountFrom: null,
    holdingAccountTo: null
    // issue: null,
    // issueClose:null,
    // issueShortcode: null, //issue_shortcode in backend
    // issueFollowup: null,
    // issueNotesInternal: null,
    // issueNotesExternal: null
  });
  const isBackOfficer = props.app_state.current_staff.backofficeStaff === 1;

  const staffID = props.app_state.current_staff.id;

  const handleOnChange = (date, dateString) => {
    setComponentState(prev => ({...prev, issueFollowup: dateString}));
  };

  const fetchCurrencies = () => {
    API.post('commons', '/fetch', {
      body: {
        context: 'currencies',
        fields: ['*'],
        condition: {deleted: false}
      }
    })
      .then(response => {
        setComponentState(prev => ({...prev, currencyList: response}));
      })
      .catch(() => {
        console.log('Failed to fetch currencies.');
      });
  };

  const fetchTransferStatus = () => {
    API.post('commons', '/fetch', {
      body: {
        context: 'admin_transfer_status',
        fields: ['*']
      }
    })
      .then(async res => {
        // Fetch holding accounts
        setComponentState(prev => ({
          ...prev,
          transferStatus: res
        }));
      })
      .catch(err => {
        console.log(err);
      });
  };

  const fetchTransferDetails = () => {
    const loading = message.loading('Fetching transfer details', 0);
    API.post('commons', '/fetch', {
      body: {
        context: 'transfers',
        fields: ['*'],
        condition: {id: props.transferId}
      }
    })
      .then(async res => {
        message.success('Transfer details loaded');

        const response = res[0];

        const holdingAccountFrom = await API.get(
          'holding_accounts',
          `/get/client-currency/${response.client_id}/${response.currency_from_id}`,
          {}
        );
        const holdingAccountTo = await API.get(
          'holding_accounts',
          `/get/client-currency/${response.client_id}/${response.currency_to_id}`,
          {}
        );

        setComponentState(prev => ({
          ...prev,
          transfer: response,
          holdingAccountFrom: holdingAccountFrom.holding_account_list[0],
          holdingAccountTo: holdingAccountTo.holding_account_list[0]
        }));
        form.setFieldsValue({
          ...response,
          issue_followup: response.issue_followup ? dayjs(response.issue_followup) : null
        });
      })
      .catch(err => {
        console.log(err);
        setComponentState(prev => ({...prev, transfer: null}));
        message.error('Fetched transfer details. Please wait..');
      })
      .finally(() => loading());
  };

  const handleSubmit = values => {
    const loading = message.loading('Saving transfer detail. Please wait..', 0);

    const payload = {
      ...values
    };

    const emailPayload = {
      staffID: staffID,
      transferID: componentState.transfer.id
    };

    API.put('transfers', `/update/id/${componentState.transfer.id}`, {body: payload})
      .then(res => {
        console.log(res);
        message.info('Transfer Detail Saved.');
        API.post('email', '/interaction/main', {
          body: {
            interaction: 'Transfer Issue has been updated',
            data: {
              staffID: staffID,
              transferID: componentState.transfer.id,
              link: `https://crm.forexworldwide.com/transfers/edit/${componentState.transfer.id}?tab=issue`
            },
            result: 'Transfer Issue has been updated'
          }
        });
        API.put('email-18', '/backoffice/transfer-issue', {body: emailPayload})
          .then(response => {
            message.info('Transfer Detail Email sent.');
          })
          .catch(error => {
            console.log('eamil sending error', error);
            message.error('Failed to send transfer detail email. Please try again..');
          });
      })
      .catch(err => {
        console.log(err);
        message.error('Failed to save transfer detail. Please try again..');
      })
      .finally(() => loading());

    // API.post("commons", `/update/${componentState.transfer.id}`, {
    //     body: {
    //         context: 'transfers',
    //         data: values
    //     }
    // }).then(res => {
    //     console.log(res);
    //     message.info("Transfer Detail Saved.");
    //     // updateLog(values);
    // }).catch(err => {
    //     console.log(err);
    //     message.error("Failed to save transfer detail. Please try again..");
    // }).finally(() => loading());
  };

  useEffect(() => {
    if (props.transferId != null) {
      fetchCurrencies();
      fetchTransferStatus();
      fetchTransferDetails();
    }
  }, [props.transferId]);

  return (
    <Form name={'transfer-issue'} form={form} layout={'vertical'} disabled={props.disabled} onFinish={handleSubmit}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Card title={'Transfer Issues'} size={'small'}>
            <Form.Item name='issue' valuePropName='checked'>
              <Checkbox>Transfer has a current issue</Checkbox>
            </Form.Item>
            <Form.Item name='issue_close' valuePropName='checked'>
              <Checkbox>Issue Close</Checkbox>
            </Form.Item>
            <Form.Item label={'Issue Shortcode'} name='issue_shortcode'>
              <Select
                showSearch={{optionFilterProp: 'label'}}
                placeholder='Select a shortcode'
                style={{width: 200}}
                options={[
                  {
                    value: 'AMOUNT',
                    label: 'AMOUNT'
                  },
                  {
                    value: 'RATE',
                    label: 'RATE'
                  },
                  {
                    value: 'BENEFICIARY',
                    label: 'BENEFICIARY'
                  },
                  {
                    value: 'PAYMENT',
                    label: 'PAYMENT'
                  },
                  {
                    value: 'OTHER',
                    label: 'OTHER'
                  }
                ]}
              />
            </Form.Item>
            <Form.Item label={'Issue Follow Up'} name='issue_followup'>
              <DatePicker onChange={handleOnChange} />
            </Form.Item>
            {isBackOfficer && (
              <Form.Item label={'Issue Notes Internal'} name='issue_notes_internal'>
                <Input.TextArea rows={5} />
              </Form.Item>
            )}
            <Form.Item label={'Issue Notes External'} name='issue_notes_external'>
              <Input.TextArea rows={5} />
            </Form.Item>
          </Card>
        </Col>
      </Row>
      <Form.Item wrapperCol={5}>
        <Button type={'primary'} htmlType={'submit'}>
          Update Issue Notes
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapStateToProps = state => ({
  app_state: state.app_state
});
const mapDispatchToProps = state => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TransferIssue);
